import React from "react";

import { API } from "config";
import { useApiHealth } from "hooks/useApiHealth";
import styles from "./ApiHealthCheck.module.scss";

interface ApiHealthCheckProps {
  children: React.ReactNode;
}

export default function ApiHealthCheck({ children }: ApiHealthCheckProps) {
  const { isHealthy, error } = useApiHealth();

  // API is unhealthy
  if (isHealthy === false) {
    return (
      <div className={styles.apiHealthCheckError}>
        <div className={styles.errorContainer}>
          <h1>⚠️ API Unreachable</h1>
          <p>
            Unable to connect to the API at <code>{API.cortevaChain.url}</code>
          </p>
          <p>
            Please ensure you are connected to the Vylor network via Zscaler or
            a direct network connection.
          </p>
          {error && (
            <details>
              <summary>Error Details</summary>
              <pre>{error.message}</pre>
            </details>
          )}
          <div className={styles.buttonRow}>
            <button
              onClick={() => window.location.reload()}
              className={styles.retryButton}
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  // API is healthy, render children
  return <>{children}</>;
}
